export default __webpack_public_path__ + "static/media/button_point-off.6f307f0c.svg";